import { out } from "@/lib/output/out";
import type { SessionDetail } from "@/lib/session/session-detail";

export function buildSessionDetailRows(session: SessionDetail): string[][] {
  const rows: string[][] = [["id", out.cell(session.id)]];
  if (session.statusReason) {
    rows.push(["reason", out.cell(session.statusReason)]);
  }
  if (session.repoFullName) {
    const branch = session.repos.find(
      (repo) => repo.repoFullName === session.repoFullName,
    )?.branch;
    rows.push([
      "repo",
      out.cell(session.repoFullName + (branch ? ` @ ${branch}` : "")),
    ]);
  }
  rows.push(["task", session.taskType]);
  if (session.model) {
    rows.push(["model", out.cell(session.model)]);
  }
  if (session.prUrl) {
    rows.push([
      "pr",
      out.cell(
        `${session.prUrl}${session.prState ? ` (${session.prState})` : ""}`,
      ),
    ]);
  }
  for (const deliverable of session.deliverables) {
    if (deliverable.url && deliverable.url !== session.prUrl) {
      rows.push([out.cell(deliverable.type), out.cell(deliverable.url)]);
    }
  }
  return rows;
}
